/* eslint-disable react/display-name */
import { Tab } from "semantic-ui-react";
import React from "react";

export const TabWrapper = (
  content: JSX.Element
): (() => JSX.Element) => (): JSX.Element => <Tab.Pane>{content}</Tab.Pane>;
